export const links = [
  {
    nombre: "Trámites y Servicios",
    link: "/Tramites",
  },
  {
    nombre: "Transparencia",
    link: "/Transparencia",
  },
  {
    nombre: "Organismos y Órganos",
    link: "/Organismos",
  },
  {
    nombre: "Información Relevante",
    link: "/Informacion",
  },
  {
    nombre: "Publicaciones",
    link: "/Informacion/Publicaciones",
  },
  {
    nombre: "Valida Documentos",
    link: "/CodigoQR",
  },
];
